import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Mark } from "@/components/ax/Mark";
import { useI18n } from "@/i18n";

export const BookCover = ({ book, locked = false, className = "" }) => {
  const { lang } = useI18n();
  return (
    <div
      data-testid={`book-cover-${book.id}`}
      className={`relative flex aspect-[2/3] flex-col overflow-hidden rounded-[12px] border border-white/10 bg-[#0B1D36] p-4 text-white shadow ${className}`}
    >
      <Mark size={24} className="text-white" />
      <div className="mt-auto">
        <p className="m-0 text-xs leading-4 text-white/70">{book.category?.[lang]}</p>
        <span aria-hidden="true" className="mt-2 block h-[2px] w-8 bg-[#0D9488]" style={{ marginBottom: 16 }} />
        <h3 className="m-0 line-clamp-3 font-display text-lg font-semibold leading-6 text-white">{book.title?.[lang] ?? book.id}</h3>
      </div>
      {locked && <Lock size={16} strokeWidth={1.5} aria-hidden="true" className="absolute right-4 top-4 text-white/70" />}
    </div>
  );
};

export const BookCard = ({ book, locked, compact = false }) => {
  const { t, lang } = useI18n();
  return (
    <Link
      to={`/library/${book.id}`}
      data-testid={`book-card-${book.id}`}
      className="block rounded-[12px] transition-opacity duration-150 hover:opacity-90"
    >
      {compact ? (
        <>
          <div aria-hidden="true" data-testid={`catalog-cover-${book.id}`}><BookCover book={book} locked={locked} /></div>
          <div data-testid={`catalog-book-details-${book.id}`}>
            <p data-testid={`catalog-book-category-${book.id}`}>{book.category?.[lang]}</p>
            <h3 data-testid={`catalog-book-title-${book.id}`} className="line-clamp-2">{book.title?.[lang] ?? book.id}</h3>
            <p data-testid={`catalog-book-summary-${book.id}`} className="m-0 line-clamp-2 text-sm leading-5 text-ax-text-2">{book.summary?.[lang]}</p>
            <p data-testid={`catalog-book-meta-${book.id}`} className="m-0 flex items-center gap-2 font-mono text-ax-muted">
              {t("lib.estimatedMinutes", { n: book.minutes })}
              {locked && <span>{t("lib.lockedCard")}</span>}
            </p>
          </div>
        </>
      ) : (
        <>
          <BookCover book={book} locked={locked} />
          <p className="m-0 mt-3 line-clamp-2 text-sm leading-5 text-ax-text-2">{book.summary?.[lang]}</p>
          <p className="m-0 mt-1 flex items-center gap-2 font-mono text-[13px] leading-[18px] text-ax-muted">
            {t("lib.estimatedMinutes", { n: book.minutes })}
            {locked && <span>{t("lib.lockedCard")}</span>}
          </p>
        </>
      )}
    </Link>
  );
};
